export default {
  productName: 'Quick Wraps',
  pathId: 'fightcamp-quick-wraps',
  description: 'These wraps secure your Trackers, add knuckle padding, and support your wrists — all in one sleek, sweat-wicking design. ',
  shortDescription: 'Wrap. Track. Protect.',
  isSoldOut: false,
  testShopifyId: 'gid://shopify/Product/7765777645657',
  prodShopifyId: 'gid://shopify/Product/8587346411756',
  primaryImg: {
    src: 'https://a.storyblok.com/f/152150/1200x825/83861d7ded/fc_product_shoot_2025-13.jpg',
    alt: 'FightCamp quick wraps',
  },
  lifestyleImage: {
    src: 'https://a.storyblok.com/f/152150/352x352/5bc6c1c45e/fc-quickwraps-thumbnail-001.png',
    alt: 'FightCamp quick wraps',
  },
  includesModalCopy: {},
  assets: [{
    src: 'https://a.storyblok.com/f/152150/1200x825/83861d7ded/fc_product_shoot_2025-13.jpg',
    alt: 'FightCamp quick wraps',
  },
  {
    src: 'https://a.storyblok.com/f/152150/1200x825/2ea9943144/fc_product_shoot_2025-25.jpg',
    alt: 'wrapping FightCamp quick wraps',
  },
  {
    src: 'https://a.storyblok.com/f/152150/1200x825/5b253f45cc/fc_product_shoot_2025-19.jpg',
    alt: 'FightCamp quick wraps with trackers',
  },
  {
    src: 'https://a.storyblok.com/f/152150/1200x825/45bc3797f3/fc_product_shoot_2025-18.jpg',
    alt: 'FightCamp quick wraps on a person',
  },
  ],
  features: [
    {
      title: 'Features',
      copy: [
        'Secure pocket for punch trackers',
        'Wrist wrap with velcro attachment',
        'Padding on knuckles',
      ],
    },
    {
      title: 'Size & Fit',
      copy: [
        'Available in S/M and L/XL',
        "L/XL is typically best for individuals taller than 5'9",
        'Stretchable fabric ensures a snug, adaptive fit',
      ],
    },
    {
      title: 'Materials & Care',
      copy: [
        'Made from 80% polyester, 20% spandex',
        'Machine washable (cold wash) and tumble dry low',
      ],
    },
  ],
};
